import React from "react";
import * as PropTypes from "prop-types";

const PlanChoicesDropdown = (props) => {
  const options = [];

  if (props.placeholder)
    options.push(<option className={`${props.optionClassName}`} key="placeholder" value="placeholder">{props.placeholder}</option>)

  for (let i = 0; i < props.plans.length; i += 1) {
    const plan = props.plans[i];
    options.push(<option className={`${props.optionClassName}`} key={plan.id} value={plan.id}>{plan.displayName}</option>);
  }

  return (
    <select className={`form-control ${props.selectClassName}`} defaultValue={props.defaultValue} onChange={event => props.onPlanSelected(event.target.value)}>
      {options}
    </select>
  );
};

PlanChoicesDropdown.defaultProps = {
  selectClassName: "",
  optionClassName: "",
  placeholder: null
};

PlanChoicesDropdown.propTypes = {
  plans: PropTypes.array.isRequired,
  onPlanSelected: PropTypes.func.isRequired,
  selectedPlan: PropTypes.object,
  defaultValue: PropTypes.number,
  selectClassName: PropTypes.string,
  optionClassName: PropTypes.string,
  placeholder: PropTypes.string
};

export default PlanChoicesDropdown;